module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l0hIb"))).then(() => parcelRequire('1iHdE'));